import React from "react";
import { AlertTriangle, Phone } from "lucide-react";

export const ResponsibleGamblingBanner = () => {
    return (
        <div
            className="fixed bottom-0 left-0 right-0 z-40 bg-[#1E3A5F] border-t border-[#2A4A6B] px-3 py-2 text-center flex items-center justify-center gap-2 sm:gap-4 text-[11px] sm:text-xs text-white"
            data-testid="responsible-gambling-banner"
        >
            <AlertTriangle
                size={14}
                className="text-[#FFB300] flex-shrink-0"
            />
            <span className="font-bold">18+</span>
            <span className="hidden sm:inline">|</span>
            <span className="hidden sm:inline">Jeu Responsable</span>
            <span className="hidden sm:inline">|</span>
            <span className="inline-flex items-center gap-1">
                <Phone size={12} className="text-[#00C853]" />
                09 74 75 13 13
            </span>
        </div>
    );
};

export default ResponsibleGamblingBanner;
